import React from "react";
import { IconButton, IconButtonProps, styled } from "@mui/material";
import { ChatFooterRootProps } from "./ChatFooter.type";

export const ChatFooterRoot: React.FC<ChatFooterRootProps> = styled("form", {
    slot: "body",
    label: "footer",
    name: "Chat",
})<ChatFooterRootProps>`
    &.ChatFooter-root {
        display: flex;
        position: relative;
        padding: 8px;
        box-sizing: border-box;
        width: 100%;
    }

    & .MuiInputBase-root {
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 0.05);
        padding-right: 48px !important; /* Espaço para o ícone */
        height: 115px;

        textarea {
            height: 100% !important;
        }
        
        &:hover {
            outline: none;
            background-color: rgba(255, 255, 255, 0.08);
        }
        
        &:focus-within {
            outline: none;
            background-color: rgba(255, 255, 255, 0.1);
        }
        
        &::before,
        &::after {
            all: unset;
        }
    }
`;

export const ChatFooterSend: React.FC<IconButtonProps> = styled(IconButton)`
    &.ChatFooter-send {
        position: absolute;
        right: 20px;
        top: 70%;
        transform: translateY(-50%);
        width: 36px;
        height: 36px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        
        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }
        
        & svg {
            width: 20px;
            height: 20px;
        }
    }
`;

export const ChatFooterOptionsWrapper = styled("div")`
    width: 100%;
    box-sizing: border-box;
    padding: 12px;
    
    & .options {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 12px;
        box-sizing: border-box;
    }

    Button {
        width: 100%;
        white-space: normal; /* Permite quebrar linha se necessário */
        background: transparent;
        padding: 12px;
        background-color: rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        text-align: center;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
            background: rgba(0, 0, 0, 0.05);
        }
    }

    @media (max-width: 600px) {
        & .options {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 400px) {
        & .options {
            grid-template-columns: 1fr;
        }
    }
`;

export default ChatFooterRoot;
